import { render, staticRenderFns } from "./UserCheckinRecordList.vue?vue&type=template&id=c39fb010&scoped=true&lang=pug&"
import script from "./UserCheckinRecordList.vue?vue&type=script&lang=ts&"
export * from "./UserCheckinRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39fb010",
  null
  
)

export default component.exports